import React, { ReactNode } from 'react';
import styled from 'styled-components';

const TextBox = styled.div`
  background: var(--gray2a);
  padding: 15px;
  text-align: center;
  font-size: var(--smaller);
  line-height: initial;
`;

const HeadingBox = styled(TextBox)`
  font-size: var(--medium);
  text-align: left;
`;

type Props = {
  children: ReactNode;
  heading?: boolean;
};

const MobileHeaderText = ({ heading = false, children }: Props) => {
  return heading ? (
    <TextBox>{children}</TextBox>
  ) : (
    <HeadingBox>{children}</HeadingBox>
  );
};

export default MobileHeaderText;
